import $ from 'jquery';
import $script from 'scriptjs';

export default class Account {
  constructor() {
    this.rechargePages = [
      '#content__customers__subscriptions',
      '#content__customers__billing',
      '#content__customers__deliver-schedule',
      '#content__customers__orders',
      '#content__customers__subscriptions__shipping-address',
      '#content__subscriptions__item',
      '#content__customers__add-products',
      '#content__customers__add-products__details'
    ];
    this.$rechargePages = $(this.rechargePages.join(', '));

    this._addClasses();
  }

  _addClasses() {
    this.$rechargePages
      .closest(document.body)
      .addClass('page-template-manage-subscriptions');
  }

  initAddresses() {
    const deferred = $.Deferred();
  
    if (!$('[data-account-template="addresses"]').length) {
      deferred.resolve();
    } else {
      const $themeScripts = $('[data-scripts]');
  
      $script($themeScripts.data('shopify-common'), () => {
        $script($themeScripts.data('shopify-customer'), () => {
          const id = $('[data-address-id]').data('address-id');
          // Initiate provinces for the New Address form
          new Shopify.CountryProvinceSelector(
            `customer-addr-${id}-country`,
            `customer-addr-${id}-province`,
            {
              hideElement: `customer-addr-${id}-province-wrapper`,
            },
          );
  
          deferred.resolve();
        });
      });
    }
  
    return deferred.promise();
  }
}
